import api from "./api";

export type SearchKind = "consulente" | "medium" | "guide";
export interface HeaderSearchResult {
	id: string;
	name: string;
	kind: SearchKind;
	photoUrl?: string | null;
	primaryMedium?: string;
	path: string;
}
interface SearchPerson {
	id: string;
	firstName: string;
	lastName: string;
	photoUrl?: string | null;
}
interface SearchGuide {
	id: string;
	name: string;
	guidePersons?: Array<{
		isActive: boolean;
		isPrimary: boolean;
		person: SearchPerson;
	}>;
}

const fullName = (person: SearchPerson) => `${person.firstName} ${person.lastName}`.trim();

export async function searchHeader(query: string) {
	const search = query.trim();
	if (search.length < 2) return { results: [], failed: false };
	const responses = await Promise.allSettled([
		api.get<{ data: SearchPerson[] }>("/persons", {
			params: { search, memberType: "CONSULENTE", mode: "select", limit: 5 },
		}),
		api.get<{ data: SearchPerson[] }>("/persons", {
			params: { search, memberType: "MEDIUM", mode: "select", limit: 5 },
		}),
		api.get<{ data: SearchGuide[] }>("/guides", {
			params: { name: search, isActive: true, limit: 5 },
		}),
	]);
	const results: HeaderSearchResult[] = [];
	responses.slice(0, 2).forEach((response, index) => {
		if (response.status !== "fulfilled") return;
		for (const person of response.value.data as SearchPerson[]) {
			results.push({ id: person.id, name: fullName(person), photoUrl: person.photoUrl,
				kind: index === 0 ? "consulente" : "medium", path: `/people/${person.id}` });
		}
	});
	const guides = responses[2];
	if (guides.status === "fulfilled") {
		for (const guide of guides.value.data as SearchGuide[]) {
			const primary = guide.guidePersons?.find(link => link.isActive && link.isPrimary)?.person;
			results.push({ id: guide.id, name: guide.name, kind: "guide", path: `/guides/${guide.id}`,
				primaryMedium: primary ? fullName(primary) : undefined, photoUrl: primary?.photoUrl });
		}
	}
	return { results, failed: responses.some(response => response.status === "rejected") };
}
